module.exports = __webpack_public_path__ + "static/media/hbuilder.1149723d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/hbuilder.png
// module id = 112
// module chunks = 0